import React, { useState } from 'react';
import { Row, Col, Spin, Result } from 'antd';
import DocumentCard from './DocumentCard';
import DocumentModal from './DocumentModal';
import RequestModal from './RequestModal';
import WipoModal from '../WIPO/WipoModal';

/**
 * Универсальная «сеточная» выдача
 *
 * @param {Array}  items          – массив объектов { document, base64Image?, score }
 * @param {boolean} loading       – флаг загрузки
 * @param {string|null} error     – текст ошибки
 * @param {string} loadingTip     – подпись к спиннеру
 * @param {string} errorTitle     – заголовок Result‑ошибки
 * @param {string} emptyTitle     – заголовок Result‑пусто
 * @param {string} requestType    – подпись, кот. уходит в избранное (используется для выбора модалки)
 * @param {Array}  extraFields    – дополнительные поля для DocumentCard
 * @param {string} searchQuery    – поисковый запрос для избранного
 * @param {string} cardDescriptionVariant – 'default' | 'semantic': при 'semantic' на карточке показывается semantic_description
 */
const ResultsGrid = ({
  items = '',
  loading = false,
  error = null,
  loadingTip = 'Загрузка…',
  errorTitle = 'Ошибка',
  emptyTitle = 'Результатов не найдено',
  requestType = '',
  extraFields = [],
  searchQuery = '',
  cardDescriptionVariant = 'default',
}) => {
  const [openDoc, setOpenDoc] = useState(null);

  const imgSrc = (obj) =>
    obj?.base64Image ? `data:image/jpg;base64,${obj.base64Image}` : null;

  // Решаем, какую модалку показывать:
  // заявки, WIPO или ТЗ
  const isRequestType =
    typeof requestType === 'string' &&
    requestType.toLowerCase().includes('заявк');
  const isWipoType =
    typeof requestType === 'string' &&
    (requestType.toLowerCase().includes('випо') ||
      requestType.toLowerCase().includes('wipo'));

  const ModalComponent = (() => {
    if (isRequestType) return RequestModal;
    if (isWipoType) return WipoModal;
    return DocumentModal; // по умолчанию — модалка для ТЗ
  })();

  if (loading) return <Spin tip={loadingTip} size="large" />;
  if (error) return <Result status="error" title={errorTitle} subTitle={error} />;
  if (items === '') return <></>;
  if (!items?.length)
    return <Result status="info" title={emptyTitle} />;

  return (
    <>
      <Row gutter={[16, 16]}>
        {items.map((item, idx) => (
          <Col key={idx} xs={24} sm={12} md={8} lg={6}>
            <DocumentCard
              document={item.document || item}
              imgSrc={imgSrc(item)}
              onClick={() => setOpenDoc(item)}
              extraFields={extraFields}
              score={item.score}
              request_type={requestType}
              csvEnrichment={item.csvEnrichment}
              hasEnrichment={item.hasEnrichment}
              searchQuery={searchQuery}
              descriptionVariant={cardDescriptionVariant}
            />
          </Col>
        ))}
      </Row>

      {isWipoType ? (
        <WipoModal
          open={!!openDoc}
          onClose={() => setOpenDoc(null)}
          data={openDoc?.document || openDoc}
          imgSrc={imgSrc(openDoc)}
        />
      ) : (
        <ModalComponent
          open={!!openDoc}
          onClose={() => setOpenDoc(null)}
          doc={openDoc}
          imgSrc={imgSrc(openDoc)}
        />
      )}
    </>
  );
};

export default ResultsGrid;
